import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[roblexInsertion]'
})
export class InsertionDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
